// Reference list of BSS user actions (UserActionID / Description)
// TODO(George): This should be fetched from the API, but for now we will keep it here as a constant
export const USER_ACTIONS_CATALOG = {
  approve_notification: { id: 1, categoryId: 4, name: 'ApproveNotification' },
  cease_subscription: { id: 2, categoryId: 4, name: 'CeaseSubscription' },
  certified_technician: { id: 3, categoryId: 3, name: 'CertifiedTechnician' },
  my_tickets: { id: 4, categoryId: 5, name: 'My tickets' },
  replicate_exact: { id: 5, categoryId: 2, name: 'ReplicateExact' },
  login_as: { id: 6, categoryId: 3, name: 'LoginAs' },
  my_orders: { id: 7, categoryId: 5, name: 'My orders' },
  manage_promotions: { id: 8, categoryId: 4, name: 'ManagePromotions' },
  process_tech_admin_exceptionally: { id: 9, categoryId: 1, name: 'ProcessTechAdminExceptionally' },
  stop_clock_reset: { id: 10, categoryId: 4, name: 'StopClockReset' },
  swap_mobile_cards_data: { id: 11, categoryId: 4, name: 'SwapMobileCardsData' },
  translate_pages: { id: 12, categoryId: 1, name: 'TranslatePages' },
  view_exceptions: { id: 13, categoryId: 1, name: 'ViewExceptions' },
  manage_users: { id: 14, categoryId: 1, name: 'Manage users' },
  my_deals: { id: 15, categoryId: 5, name: 'My deals' },
  my_contracts: { id: 16, categoryId: 5, name: 'My contracts' },
  my_quotations: { id: 17, categoryId: 5, name: 'My quotations' },
  my_invoices: { id: 18, categoryId: 5, name: 'My invoices' },
  my_outstanding_amounts: { id: 19, categoryId: 5, name: 'My outstanding amounts' },
  my_sepa_mandate: { id: 20, categoryId: 5, name: 'My SEPA mandate' },
  my_reminders: { id: 21, categoryId: 5, name: 'My reminders' },
  my_average_usage: { id: 22, categoryId: 5, name: 'My average usage' },
  my_customer_details: { id: 23, categoryId: 5, name: 'My customer details' },
  my_configuration: { id: 24, categoryId: 5, name: 'My configuration' },
  order_online: { id: 25, categoryId: 5, name: 'Order online' },
  my_commissions: { id: 26, categoryId: 5, name: 'My commissions' },
  create_employee: { id: 27, categoryId: 1, name: 'CreateEmployee' },
  edit_employee: { id: 28, categoryId: 1, name: 'EditEmployee' },
  view_employee: { id: 29, categoryId: 3, name: 'ViewEmployee' },
  manage_employees: { id: 30, categoryId: 1, name: 'ManageEmployees' },
  block_user: { id: 31, categoryId: 3, name: 'BlockUser' },
  cancel_subscription: { id: 32, categoryId: 4, name: 'CancelSubscription' },
  send_change_xml: { id: 33, categoryId: 4, name: 'SendChangeXML' },
  change_article_price: { id: 34, categoryId: 3, name: 'ChangeArticlePrice' },
  online_shop_nl: { id: 35, categoryId: 5, name: 'Online shop NL' },
  terminate_mobile: { id: 36, categoryId: 4, name: 'TerminateMobile' },
  manage_linemon_users: { id: 37, categoryId: 1, name: 'Manage Linemon Users' },
  my_agreements: { id: 38, categoryId: 5, name: 'My agreements' },
  create_customer: { id: 39, categoryId: 3, name: 'CreateCustomer' },
  view_bill_run: { id: 40, categoryId: 2, name: 'ViewBillRun' },
  edit_bill_run: { id: 41, categoryId: 2, name: 'EditBillRun' },
  order_approval: { id: 42, categoryId: 4, name: 'OrderApproval' },
  financial_approval: { id: 43, categoryId: 2, name: 'FinancialApproval' },
  sim_assign: { id: 44, categoryId: 4, name: 'SimAssign' },
  sim_swap: { id: 45, categoryId: 4, name: 'simSwap' },
  edit_mnp: { id: 46, categoryId: 4, name: 'EditMNP' },
  bulk_template_tool: { id: 47, categoryId: 3, name: 'BulkTemplateTool' },
  my_own_tickets: { id: 48, categoryId: 7, name: 'My own tickets' },
  cdr_details: { id: 49, categoryId: 3, name: 'CDR Details' },
  my_documents: { id: 50, categoryId: 5, name: 'My Documents' },
  delete_documents: { id: 51, categoryId: 3, name: 'Delete documents' },
  manage_documents: { id: 52, categoryId: 3, name: 'Manage documents' },
  mpn_sim_management: { id: 53, categoryId: 5, name: 'MPN SIM Management' },
  partner_tools: { id: 54, categoryId: 7, name: 'Partner tools' },
  create_deal: { id: 55, categoryId: 5, name: 'Create deal' },
  create_user: { id: 56, categoryId: 1, name: 'Create user' },
  sim_management: { id: 57, categoryId: 4, name: 'SIM Management' },
  my_department_tickets: { id: 58, categoryId: 7, name: 'My department tickets' },
  admin_mobile_actions: { id: 59, categoryId: 4, name: 'AdminMobileActions' },
  change_main_user: { id: 60, categoryId: 1, name: 'ChangeMainUser' },
  create_ticket: { id: 61, categoryId: 7, name: 'Create ticket' },
  download_cdr_details: { id: 62, categoryId: 7, name: 'Download CDR Details' },
  split_number_change: { id: 63, categoryId: 1, name: 'SplitNumberRange' },
  edit_barrings: { id: 64, categoryId: 4, name: 'Edit barrings' },
  edit_usage_warnings: { id: 65, categoryId: 4, name: 'Edit usage warnings' },
} as const

export type UserActionKey = keyof typeof USER_ACTIONS_CATALOG
export type UserActionCatalogItem = (typeof USER_ACTIONS_CATALOG)[UserActionKey]
